export default __webpack_public_path__ + "static/media/SheetMetalImg.7647d9e1.png";